import req from "../http";

const recruitment = {
  // 取得 所有職缺(for複製歷史需求單)
  getJobs(params) {
    return req("get", "/Recruitment/GetJobManagementAll", params);
  },

  // 取得 面談紀錄(for填寫面談紀錄)
  postInterviewRecord(params) {
    return req("post", "/Recruitment/WriteInterviewRecord", params);
  },

  // 取得面談評估-錄取的[備註]下拉選單
  getInterviewBasicCondition(params) {
    return req("get", "/Recruitment/InterviewBasicCondition", params);
  },

  // 取得面談評估-不錄取相關下拉選單
  getInterviewNotAdmitReason(params) {
    return req("get", "/Recruitment/InterviewNotAdmitReason", params);
  },

  // 送出 面談紀錄
  putInterviewRecord(params) {
    return req("put", "/Recruitment/InterviewRecord", params);
  },

  // 完成報到
  onBoard(params) {
    return req("put", "/Recruitment/OnBoard", params);
  },

  // 依據 UserId 取得應徵的職缺清單(後台)
  getJobByUserOfBack(email) {
    return req("get", `/Recruitment/GetJobByEmail/${email}`);

  },

  // 依據 UserId 取得應徵的職缺清單(前台)
  getJobByUserOfFront(userId) {
    return req("get", `/Recruitment/GetJobByUser/FrontEnd/${userId}`);
  },

  // 依據 MatchId 取得招募歷程(前台)
  getJobHistoryByUserOfFront(matchId) {
    return req("get", `/Recruitment/GetJobHistoryByUser/FrontEnd/${matchId}`);
  },

  // 依據 MatchId 取得招募歷程(後台)
  getJobHistoryByUserOfBack(matchId) {
    return req("get", `/Recruitment/GetJobHistoryByUser/Backend/${matchId}`);
  },

  // 依據 InterviewId 取得面談邀約信內容
  getNoticeOfInterviewMail(interviewId) {
    return req("get", `/Recruitment/GetInterviewMail/${interviewId}`);
  },

  // 匯出 Offer 
  downloadOffer(params) {
    return req("post", "/Recruitment/Offer/Export", params, { responseType: "blob" });
  },
};

export default recruitment;